<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M2.42553 5.84308H9.44681V8.03457C9.44681 8.26862 9.6383 8.4601 9.87234 8.4601C10.1064 8.4601 10.2979 8.26862 10.2979 8.03457V5.84308H21.5745C21.8085 5.84308 22 5.65159 22 5.41755C22 5.18351 21.8085 4.99202 21.5745 4.99202H10.2979V2.80053C10.2979 2.56649 10.1064 2.375 9.87234 2.375C9.6383 2.375 9.44681 2.56649 9.44681 2.80053V4.99202H2.42553C2.19149 4.99202 2 5.18351 2 5.41755C2 5.65159 2.19149 5.84308 2.42553 5.84308Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M21.5745 11.9495H16.6809V9.75798C16.6809 9.52394 16.4894 9.33245 16.2553 9.33245C16.0213 9.33245 15.8298 9.52394 15.8298 9.75798V11.9495H2.42553C2.19149 11.9495 2 12.141 2 12.375C2 12.609 2.19149 12.8005 2.42553 12.8005H15.8298V14.992C15.8298 15.2261 16.0213 15.4176 16.2553 15.4176C16.4894 15.4176 16.6809 15.2261 16.6809 14.992V12.8005H21.5745C21.8085 12.8005 22 12.609 22 12.375C22 12.141 21.8085 11.9495 21.5745 11.9495Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M21.5745 18.9069H8.17021V16.7154C8.17021 16.4814 7.97872 16.2899 7.74468 16.2899C7.51064 16.2899 7.31915 16.4814 7.31915 16.7154V18.9069H2.42553C2.19149 18.9069 2 19.0984 2 19.3324C2 19.5665 2.19149 19.758 2.42553 19.758H7.31915V21.9495C7.31915 22.1835 7.51064 22.375 7.74468 22.375C7.97872 22.375 8.17021 22.1835 8.17021 21.9495V19.758H21.5745C21.8085 19.758 22 19.5665 22 19.3324C22 19.0984 21.8085 18.9069 21.5745 18.9069Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
